import axios from "axios";
import qs from 'qs';

///wp-json/jwt-auth/v1/token
export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig();
  const userStore = useUserStore();

  const version = new Date().getTime();

  const axiosInstance = axios.create({
      baseURL: config.public.BASE_URL + 'api/',
      headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${userStore.csrf}`,
      },
      params: {
        ver: version
      },
      paramsSerializer: function (params) {
        return qs.stringify(params, {arrayFormat: 'brackets'})
      },
      withCredentials: true
  });
  // axiosInstance.defaults.headers.Authorization = null;
  axiosInstance.interceptors.request.use(function (config) {
    return config;
  }, function (error) {
    return Promise.reject(error);
  });

  axiosInstance.interceptors.response.use(function (response) {
    if (response.status == 200 && process.client) {
      var evt = new Event("alt_load", {"bubbles": true, "cancelable": false});
      window.document.dispatchEvent(evt);
    }

    return response.data;
  }, function (error) {
    // const originalRequest = error.config;
    // console.log('originalRequest', originalRequest);
    // if( error.response?.status === 410 && ! originalRequest._retry ) {
    //   originalRequest._retry = true;

    //   try {
    //     const refreshResponse = await axiosInstance.get('/data/csrf/refresh/');

    //     console.log('Refresh token', refreshResponse);
    //   } catch (refreshError) {

    //   }
    // }
    // console.log('axiosInstanceError', error.response?.status);
    if( typeof error.response != 'undefined' && typeof error.response.data != 'undefined' ) {
      error = error.response;
    }

    return Promise.reject(error);
  });


  const fileInstance = axios.create({
    baseURL: config.public.BASE_URL + 'file/',
    headers: {
        Accept: 'application/json',
        'X-API-Key': userStore.csrf,
    },
    params: {
      ver: version
    },
    paramsSerializer: function (params) {
      return qs.stringify(params, {arrayFormat: 'brackets'})
    },
    withCredentials: true
  });

  fileInstance.interceptors.request.use(function (config) {
    return config;
  }, function (error) {
    return Promise.reject(error);
  });

  fileInstance.interceptors.response.use(function (response) {
    if (response.status == 200 && process.client) {
      var evt = new Event("alt_load", {"bubbles": true, "cancelable": false});
      window.document.dispatchEvent(evt);
    }
    return response.data;
  }, function (error) {
    if(typeof error.response != 'undefined' && typeof error.response.data != 'undefined') {
      error = error.response;
    }
    return Promise.reject(error);
  });


  return {
    provide: {
      ajax: axiosInstance,
      file: fileInstance
    }
  }
})
